<template>
  <div>
    <Header style="position:absolute" />
    <div class="contentBox">
      <!-- 第一模块 -->
      <div class="banner">
        <div class="titleBox">
          <h2>Nosotros</h2>
          <p>
            Somos especilistas en brindar apoyo <br />
            económico en todo momento y al <br />
            alcance de tu mano. Solo descarga <br />
            la aplicación y en minutos tendrás el <br />
            préstamo en tu cuenta.
          </p>
        </div>
        <img src="../../assets/image/newImage/sobreBanner.png" alt="" />
      </div>
      <!-- concat模块 -->
      <div class="concatBox">
        <h2>Contáctanos</h2>
        <p>¿Necesitas más ayuda? ¡Conversa con nosotros!</p>
        <div class="divider"></div>
        <div class="concatList">
          <div class="concat" style="margin-bottom: 72px;">
            <div style="margin-right: 19.5%;">
              <img src="../../assets/image/newImage/concat1.png" alt="" />
              <p>
                Atención al Cliente <br />
                +51 {{ phone }}
                <!-- +51 17309229 -->
              </p>
            </div>
            <div>
              <img src="../../assets/image/newImage/concat2.png" alt="" />
              <p>
                Horario de Atención: <br />
                {{ daySection[0] }}<br />{{ daySection[1] || "" }}
                <!-- LUN-VIER 9:00 A 18:40 <br />
                SAB 9:00 A 14:40 -->
              </p>
            </div>
          </div>
          <div class="concat">
            <div style="margin-right: 18.9%;">
              <img src="../../assets/image/newImage/concat3.png" alt="" />
              <p>
                Email: <br />
                servicio@credisol.pe
              </p>
            </div>
            <div>
              <img src="../../assets/image/newImage/concat4.png" alt="" />
              <p>
                WhatsApp: <br />
                +51 {{ whatsApp }}
                <!-- +51 924267231 -->
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../../components/newHeader.vue";
import Footer from "../../components/newFooter.vue";
export default {
  components: {
    Header,
    Footer,
  },

  data() {
    return {
      whatsApp: "",
      phone: "",
      daySection: [],
    };
  },

  mounted() {
    const data = JSON.parse(localStorage.getItem("customerData"));
    this.whatsApp = data.customerServiceWhatsApp.whatsApp;
    this.phone = data.customerServicePhone.phone;
    this.daySection = data.customerServiceWorkTimeInfo.daySection.split(",");
  },
};
</script>

<style lang="scss" scoped>
* {
  list-style: none;
  box-sizing: border-box;
}
.contentBox {
  .banner {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 75px;
    width: 100%;
    height: 612px;
    background: linear-gradient(307deg, #f98043 0%, #c90000 100%);
    .titleBox {
      margin-right: 170px;
      h2 {
        font-size: 46px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: #ffc029;
        margin-bottom: 32px;
      }
      p {
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
    }
    img {
      width: 401px;
      height: 401px;
    }
  }
  .concatBox {
    height: 650px;
    padding-top: 100px;
    background-color: #f5f6f7;
    h2 {
      text-align: center;
      font-size: 42px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: #c90000;
    }
    & > p {
      font-size: 32px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #ffc029;
      margin: 20px 0 40px;
      text-align: center;
    }
    .divider {
      width: 612px;
      height: 3px;
      margin: 0 auto;
      margin-bottom: 95px;
      background-color: #c90000;
    }
    .concatList {
      padding-left: 26%;
      .concat {
        display: flex;
        div {
          display: flex;
          align-items: center;
          font-size: 24px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #333333;
          p {
            text-align: left;
            margin-left: 32px;
          }
          img {
            width: 70px;
            height: 70px;
          }
        }
      }
    }
  }
}
</style>
